import { render } from "./DetailText.vue?vue&type=template&id=10f31b03&scoped=true"
import script from "./DetailText.vue?vue&type=script&lang=js"
export * from "./DetailText.vue?vue&type=script&lang=js"

import "./DetailText.vue?vue&type=style&index=0&id=10f31b03&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f31b03"]])

export default __exports__